import React from "react";
import { Pagination } from "react-bootstrap";

function PaginationComponent({
  currentPage,
  totalPages,
  handlePageChange,
  pagesToShow,
}) {
  // Calculate the range of page numbers to display
  let startPage = Math.max(currentPage - Math.floor(pagesToShow / 2), 1);
  let endPage = Math.min(startPage + pagesToShow - 1, totalPages);

  // Adjust the startPage and endPage to ensure we display 'pagesToShow' pages
  if (totalPages - endPage < Math.floor(pagesToShow / 2)) {
    startPage = Math.max(endPage - pagesToShow + 1, 1);
  }

  const pageNumbers = [];

  // Add "First" and "Prev" buttons
  if (currentPage > 1) {
    pageNumbers.push(
      <Pagination.First key="first" onClick={() => handlePageChange(1)} />
    );
    pageNumbers.push(
      <Pagination.Prev
        key="prev"
        onClick={() => handlePageChange(currentPage - 1)}
      />
    );
  }

  // Add page numbers with ellipses
  Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index).forEach((i) => {
    pageNumbers.push(
      <Pagination.Item
        key={i}
        active={i === currentPage}
        onClick={() => handlePageChange(i)}
      >
        {i}
      </Pagination.Item>
    );
  });

  // Add "Next" and "Last" buttons
  if (currentPage < totalPages) {
    pageNumbers.push(
      <Pagination.Next
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
      />
    );
    pageNumbers.push(
      <Pagination.Last
        key="last"
        onClick={() => handlePageChange(totalPages)}
      />
    );
  }

  return <Pagination>{pageNumbers}</Pagination>;
}

export default PaginationComponent;
